
export const BackgroundAnimation = () => `
    <div id="bg-animation">
        <div class="light-orb orb-1"></div>
        <div class="light-orb orb-2"></div>
        <div class="light-orb orb-3"></div>
        <div class="grid-overlay"></div>
    </div>
`;
